import { faXmarkLarge } from "@fortawesome/pro-solid-svg-icons";
import {
  FontAwesomeIcon,
  type FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

const XMarkIcon = ({ ...props }: Omit<FontAwesomeIconProps, "icon">) => (
  <FontAwesomeIcon icon={faXmarkLarge} {...props} title={undefined} />
);

export { XMarkIcon };
